document.addEventListener('DOMContentLoaded', function () {
  var drawer = document.getElementById('panda-cart-drawer');
  if (!drawer) return;

  var overlay = document.getElementById('panda-cart-overlay');
  var closeBtn = document.getElementById('panda-cart-close');
  var itemsWrap = document.getElementById('panda-cart-items');
  var threshold = parseInt(drawer.dataset.freeShippingThreshold, 10) || 0;

  // Trava o botão de finalizar compra enquanto qualquer alteração do
  // carrinho estiver em andamento (adicionar, mudar quantidade, remover) —
  // evita que o cliente consiga ir pro checkout no meio de uma operação,
  // quando o carrinho real da Shopify pode estar num estado intermediário
  // (ex.: removendo uma aliança + o solitário grátis vinculado a ela em
  // mais de uma requisição). Contador em vez de booleano pra aguentar
  // operações sobrepostas (cliques rápidos em sequência) sem destravar cedo
  // demais enquanto outra ainda está em andamento.
  var cartMutationCount = 0;
  function lockCheckout() {
    cartMutationCount++;
    var checkoutBtn = document.querySelector('.panda-cart-checkout-btn');
    if (checkoutBtn) checkoutBtn.classList.add('panda-is-locked');
  }
  function unlockCheckout() {
    cartMutationCount = Math.max(0, cartMutationCount - 1);
    if (cartMutationCount > 0) return;
    var checkoutBtn = document.querySelector('.panda-cart-checkout-btn');
    if (checkoutBtn) checkoutBtn.classList.remove('panda-is-locked');
  }
  document.addEventListener('click', function (e) {
    var checkoutBtn = e.target.closest('.panda-cart-checkout-btn');
    if (checkoutBtn && checkoutBtn.classList.contains('panda-is-locked')) {
      e.preventDefault();
    }
  });

  function openDrawer() {
    drawer.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    drawer.classList.remove('open');
    document.body.style.overflow = '';
  }

  function moneyFromCents(cents) {
    return (cents / 100).toLocaleString('pt-BR', { style: 'currency', currency: window.Shopify && Shopify.currency ? Shopify.currency.active : 'BRL' });
  }

  function updateShippingMessage(totalCents) {
    var el = document.getElementById('panda-cart-shipping');
    if (!el || !threshold) {
      if (el) el.innerHTML = '';
      return;
    }
    var truckSvg = '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><rect x="1" y="3" width="15" height="13"/><path d="M16 8h4l3 3v5h-7V8z"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>';
    if (totalCents >= threshold) {
      el.className = 'panda-cart-shipping panda-cart-shipping--ok';
      el.innerHTML = truckSvg + ' Você ganhou frete grátis!';
    } else {
      el.className = 'panda-cart-shipping panda-cart-shipping--pending';
      el.innerHTML = truckSvg + ' Adicione mais ' + moneyFromCents(threshold - totalCents) + ' para frete grátis';
    }
  }

  function fetchRecommendations() {
    var track = document.getElementById('panda-cart-rec-track');
    var rec = document.getElementById('panda-cart-rec');
    if (!track || !rec) return;
    fetch(window.Shopify.routes.root + 'cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart.items.length) {
          rec.style.display = 'none';
          return;
        }
        var productId = cart.items[0].product_id;
        var url =
          window.pandaRoutes.productRecommendationsUrl +
          '?section_id=panda-cart-recommendations&product_id=' +
          productId +
          '&limit=10&intent=related';
        fetch(url)
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var wrapper = doc.getElementById('shopify-section-panda-cart-recommendations');
            track.innerHTML = wrapper ? wrapper.innerHTML : doc.body.innerHTML;
            rec.style.display = track.innerHTML.trim() ? '' : 'none';
          });
      });
  }

  function renderCart(cart) {
    document.getElementById('panda-cart-count').textContent =
      cart.item_count + ' ' + (cart.item_count === 1 ? window.pandaCartStrings.itemSingular : window.pandaCartStrings.itemPlural);
    document.getElementById('panda-cart-subtotal').textContent = moneyFromCents(cart.total_price);
    var installmentsCount = window.pandaCartStrings.installmentsCount || 3;
    document.getElementById('panda-cart-parcel').textContent =
      window.pandaCartStrings.installmentsLabel + ' ' + installmentsCount + 'x ' + moneyFromCents(cart.total_price / installmentsCount);
    updateShippingMessage(cart.total_price);

    var badge = document.querySelector('.panda-nav__cart-badge');
    var cartIconBtn = document.getElementById('panda-cart-toggle');
    if (cart.item_count > 0) {
      if (!badge && cartIconBtn) {
        badge = document.createElement('span');
        badge.className = 'panda-nav__cart-badge';
        cartIconBtn.appendChild(badge);
      }
      if (badge) badge.textContent = cart.item_count;
    } else if (badge) {
      badge.remove();
    }

    itemsWrap.style.display = cart.item_count > 0 ? 'block' : 'none';
    document.getElementById('panda-cart-empty').style.display = cart.item_count > 0 ? 'none' : 'flex';
    document.getElementById('panda-cart-footer').style.display = cart.item_count > 0 ? 'block' : 'none';
    document.getElementById('panda-cart-rec').style.display = cart.item_count > 0 ? '' : 'none';

    itemsWrap.innerHTML = cart.items
      .map(function (item, index) {
        var gravLines = [];
        for (var key in item.properties || {}) {
          // chaves com "_" na frente são metadados internos (ex: vínculo do
          // solitário Avis com o produto principal) — convenção nativa da
          // Shopify pra property oculta do cliente, não deve aparecer aqui.
          if (item.properties[key] && key.charAt(0) !== '_') {
            gravLines.push('<div class="panda-cart-item__grav">' + key + ': "' + item.properties[key] + '"</div>');
          }
        }
        var gravHtml = gravLines.length
          ? gravLines.join('')
          : '<div class="panda-cart-item__grav panda-cart-item__grav--empty">' + window.pandaCartStrings.noEngraving + '</div>';
        var variantTitle = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
        var isBundleLinked = item.properties && item.properties['_panda_avis_bundle_parent'];
        var qtyHtml = isBundleLinked
          ? '<div class="panda-cart-qty panda-cart-qty--locked"><span class="panda-qty-val">' + item.quantity + '</span></div>'
          : '<div class="panda-cart-qty">' +
            '<button class="panda-qty-btn" data-cart-qty-decrease>−</button>' +
            '<span class="panda-qty-val">' + item.quantity + '</span>' +
            '<button class="panda-qty-btn" data-cart-qty-increase>+</button>' +
            '</div>';
        var priceHtml = item.final_line_price === 0 ? window.pandaCartStrings.freePriceLabel : moneyFromCents(item.final_line_price);
        return (
          '<div class="panda-cart-item" data-line="' +
          (index + 1) +
          '" data-key="' +
          item.key +
          '" data-variant-id="' +
          item.variant_id +
          '" data-bundle-parent="' +
          (item.properties && item.properties['_panda_avis_bundle_parent'] || '') +
          '" data-bundle-property-key="' +
          (item.properties && item.properties['_panda_avis_bundle_property_key'] || '') +
          '" data-bundle-owner="' +
          (item.properties && item.properties['_panda_avis_bundle_owner'] || '') +
          '" data-final-line-price="' +
          item.final_line_price +
          '">' +
          '<a href="' + item.url + '" class="panda-cart-item__img"><img src="' + item.image + '&width=160" alt="' + item.product_title + '" width="80" height="80"></a>' +
          '<div class="panda-cart-item__info">' +
          '<a href="' + item.url + '" class="panda-cart-item__name">' + item.product_title + '</a>' +
          (variantTitle ? '<div class="panda-cart-item__meta">' + variantTitle + '</div>' : '') +
          gravHtml +
          '<div class="panda-cart-item__bottom">' +
          qtyHtml +
          '<div class="panda-cart-item__price">' + priceHtml + '</div>' +
          '</div></div>' +
          '<button class="panda-cart-item__remove" data-cart-remove aria-label="Remover item"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg></button>' +
          '</div>'
        );
      })
      .join('');

    fetchRecommendations();
  }

  function refreshCart() {
    return fetch(window.Shopify.routes.root + 'cart.js')
      .then(function (r) { return r.json(); })
      .then(renderCart);
  }

  // Quando um item de bundle Avis (grátis ou pago) é removido do carrinho, a
  // property de resumo da aliança-mãe (ex.: "Solitário escolhido: Anel
  // Solitário Cravejado", montada em panda-produto-main.js) precisa ser
  // recalculada — senão ela fica presa ao texto de quando o item foi
  // adicionado, indicando um solitário que não está mais no carrinho e não
  // foi cobrado (aparece assim até no checkout). Reconstrói a property só
  // com quem sobrou de verdade pra essa aliança + esse mesmo grupo de opção,
  // sem mexer nas outras properties dela nem em outras alianças do carrinho.
  function syncParentBundleProperty(cart, parentOwnerId, propertyKey) {
    if (!parentOwnerId || !propertyKey) return Promise.resolve(cart);
    var parentIndex = -1;
    var parentItem = null;
    cart.items.forEach(function (item, idx) {
      if (item.properties && item.properties['_panda_avis_bundle_owner'] === parentOwnerId) {
        parentIndex = idx;
        parentItem = item;
      }
    });
    if (!parentItem) return Promise.resolve(cart);

    var remainingLabels = [];
    cart.items.forEach(function (item) {
      var itsParent = item.properties && item.properties['_panda_avis_bundle_parent'];
      var itsKey = item.properties && item.properties['_panda_avis_bundle_property_key'];
      if (itsParent && itsParent === parentOwnerId && itsKey === propertyKey) {
        remainingLabels.push(item.properties['_panda_avis_bundle_label']);
      }
    });

    var newProperties = Object.assign({}, parentItem.properties);
    if (remainingLabels.length) {
      newProperties[propertyKey] = remainingLabels.join(',');
    } else {
      delete newProperties[propertyKey];
    }

    return fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: parentIndex + 1, quantity: parentItem.quantity, properties: newProperties }),
    }).then(function (r) { return r.json(); });
  }

  function changeLine(line, quantity, btn) {
    var itemEl = itemsWrap.querySelector('.panda-cart-item[data-line="' + line + '"]');
    var itemKey = itemEl ? itemEl.dataset.key : null;
    if (!itemKey) return;

    var isRemoval = quantity === 0;
    var removedOwnerId = isRemoval ? itemEl.dataset.bundleOwner : null;
    var removedBundleParent = isRemoval ? itemEl.dataset.bundleParent : null;
    var removedBundlePropertyKey = isRemoval ? itemEl.dataset.bundlePropertyKey : null;

    var updates = {};
    updates[itemKey] = quantity;

    // Se o item removido é uma aliança-mãe com solitário(s) grátis vinculados
    // (mesmo _panda_avis_bundle_owner), inclui a remoção deles NA MESMA
    // chamada de /cart/update.js — em vez de duas requisições sequenciais
    // (o jeito antigo), o que deixava o carrinho real (o mesmo que o
    // checkout acessa) com uma janela genuína, entre uma chamada e outra, só
    // com o grátis sobrando sem o produto principal e sem cobrança. Uma
    // chamada só, atômica, elimina essa janela por completo.
    if (removedOwnerId) {
      itemsWrap.querySelectorAll('.panda-cart-item[data-bundle-parent="' + removedOwnerId + '"]').forEach(function (bundleEl) {
        if (bundleEl.dataset.finalLinePrice === '0' && bundleEl.dataset.key) {
          updates[bundleEl.dataset.key] = 0;
        }
      });
    }

    lockCheckout();
    fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates }),
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!removedBundleParent) return cart;
        return syncParentBundleProperty(cart, removedBundleParent, removedBundlePropertyKey);
      })
      .then(renderCart)
      .catch(function (err) {
        console.error('panda: falha ao atualizar carrinho', err);
        if (btn) btn.classList.remove('panda-btn-loading');
      })
      .finally(unlockCheckout);
  }

  itemsWrap.addEventListener('click', function (e) {
    var itemEl = e.target.closest('.panda-cart-item');
    if (!itemEl) return;
    var btn = e.target.closest('[data-cart-qty-increase], [data-cart-qty-decrease], [data-cart-remove]');
    if (!btn || btn.classList.contains('panda-btn-loading')) return;
    var line = parseInt(itemEl.dataset.line, 10);
    var qtyVal = itemEl.querySelector('.panda-qty-val');
    var currentQty = parseInt(qtyVal.textContent, 10);
    btn.classList.add('panda-btn-loading');

    if (btn.hasAttribute('data-cart-qty-increase')) {
      changeLine(line, currentQty + 1, btn);
    } else if (btn.hasAttribute('data-cart-qty-decrease')) {
      changeLine(line, currentQty - 1, btn);
    } else if (btn.hasAttribute('data-cart-remove')) {
      changeLine(line, 0, btn);
    }
  });

  function addToCart(items) {
    lockCheckout();
    return fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items }),
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (err) { throw err; });
        return r.json();
      })
      .then(function (result) {
        return refreshCart().then(function () { return result; });
      })
      .then(function (result) {
        openDrawer();
        return result;
      })
      .finally(unlockCheckout);
  }
  window.pandaAddToCart = addToCart;

  document.addEventListener('click', function (e) {
    var addBtn = e.target.closest('[data-cart-add]');
    if (!addBtn || addBtn.classList.contains('panda-btn-loading')) return;
    addBtn.classList.add('panda-btn-loading');
    addBtn.disabled = true;
    addToCart([{ id: addBtn.dataset.variantId, quantity: 1 }])
      .catch(function (err) { console.error('panda: falha ao adicionar ao carrinho', err); })
      .finally(function () {
        addBtn.classList.remove('panda-btn-loading');
        addBtn.disabled = false;
      });
  });

  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  if (overlay) overlay.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('#panda-cart-toggle');
    if (!toggle) return;
    e.preventDefault();
    openDrawer();
    fetchRecommendations();
  });

  document.addEventListener('panda:cart:refresh', refreshCart);
  document.addEventListener('panda:cart:open', openDrawer);

  // Popula as recomendações já no carregamento da página (cobre o caso de o
  // carrinho já ter itens de uma visita anterior, sem precisar de nenhuma
  // mutação nova pra disparar a busca).
  fetchRecommendations();

  window.pandaOpenCartDrawer = openDrawer;
});
